import { graphql } from "gql";

const PAGED_MESSAGE_LIST_QUERY = graphql(`
  query PagedMessageList($input: MessageListInput!) {
    pagedMessageList(input: $input) {
      ...Message
    }
  }
`);

export default PAGED_MESSAGE_LIST_QUERY;
